import { HideText } from 'common-modules/general/assets/Styles/Common.style';
import { BlackBurgetIcon, BurgerIcon } from 'common-modules/general/assets/Styles/Mobile/icon';
import { RoutesString } from 'common-modules/general/Config/routesString';
import MobxStore from 'common-modules/general/Store/MobxStore';
import { observer } from 'mobx-react';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logo from 'common-modules/general/assets/Mobile/images/common/logo.png';

interface HeaderProps {
  isBanner: boolean;
  menuFn?: () => void;
  isFixed?: boolean;
  headerPos?: Number;
}

const ContentWrapper = styled.div<Omit<HeaderProps, 'isBanner'>>`
  width: 100%;
  position: absolute;
  z-index: 180;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 3.25rem;
  background-color: transparent;

  &.fixed {
    height: 3.25rem;
    position: fixed;
    top: 0px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
  }
`;
const GoLink = styled.a`
  position: absolute;
  z-index: 3;
  width: 39px;
  width: 2.4375rem;
  height: 18px;
  height: 1.125rem;
  top: 16px;
  top: 1rem;
  left: 15px;
  left: 0.9375rem;
  background: url(${logo}) no-repeat left top;
  background-size: 39px 18px;
  background-size: 2.4375rem 1.125rem;
`;

const Title = styled.h1``;

const PrevIcon = styled.i`
  position: absolute;
  width: 39px;
  width: 2.4375rem;
  height: 18px;
  height: 1.125rem;
  top: 16px;
  top: 1rem;
  left: 15px;
  left: 0.9375rem;
  background: url(${logo}) no-repeat left top;
  background-size: 39px 18px;
  background-size: 2.4375rem 1.125rem;
`;

const MenuBtn = styled.button`
  position: absolute;
  width: 66px;
  width: 4.125rem;
  height: 51px;
  height: 3.1875rem;
  top: 0;
  right: 0;
`;

const SubTitle = styled.div`
  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 1.125rem;
  font-family: 'SDGothicNeobTTF-eSm';
  line-height: 1.2;
  white-space: nowrap;
`;

const HeaderContent: React.FC<HeaderProps> = observer(({ isBanner, menuFn, isFixed, headerPos }) => {
  const location = useLocation();
  const { mobileHeader } = MobxStore();

  const renderSubTitle = () => {
    let subTitle = '';

    if (mobileHeader.mobileHeaderTitle) {
      subTitle = mobileHeader.mobileHeaderTitle;

      return subTitle;
    }

    if (location.pathname.startsWith(`${RoutesString.Skill}/`)) {
      /* Brand > skill > skill detail 예외 처리 */
      subTitle = 'Expert Solution';

      return subTitle;
    }

    switch (location.pathname) {
      case RoutesString.JoinMember:
        subTitle = '회원가입';
        break;
      case RoutesString.Reapply:
        subTitle = '개인정보 재동의';
        break;
      case RoutesString.FamilRV:
      case RoutesString.FamilyRVTime:
        subTitle = '입주자 사전방문행사 예약';
        break;
      case RoutesString.MyPage:
        subTitle = '종합 정보';
        break;
      case RoutesString.MoveIn:
      case RoutesString.MoveInTime:
      case RoutesString.BookingInfor:
        subTitle = '입주 예약';
        break;
      case RoutesString.LocationVerify:
        subTitle = '계약자 정보확인';
        break;
      case RoutesString.Payment:
      case RoutesString.PaymentApart:
      case RoutesString.Separately:
        subTitle = '분양 대금 납부 조회';
        break;
      case RoutesString.DormantAccount:
        subTitle = '계정 휴면 해제';
        break;
      case RoutesString.Product:
        subTitle = '상품';
        break;
      case RoutesString.Brand:
      case RoutesString.Bi:
      case RoutesString.History:
        subTitle = '브랜드 스토리';
        break;
      case RoutesString.Skill:
        subTitle = '기술';
        break;
      case RoutesString.BrandNews:
        subTitle = '브랜드 뉴스';
        break;
      case RoutesString.AsSection01:
      case RoutesString.AsApply:
        subTitle = 'A/S 신청';
        break;
      case RoutesString.Complex:
      case RoutesString.ComplexInfo:
        subTitle = '단지 소식';
        break;
      case RoutesString.Ventilation:
        subTitle = '환기 필터 케어';
        break;
      case RoutesString.Policy:
        subTitle = '영상정보처리기기 운영 및 관리방침';
        break;
      case RoutesString.Agree:
        subTitle = '이용약관';
        break;
      case RoutesString.Person:
        subTitle = '개인정보처리방침';
        break;
      case RoutesString.Sitemap:
        subTitle = '사이트맵';
        break;
      case RoutesString.LivingGuide:
        subTitle = 'eLife 가이드';
        break;
      case RoutesString.ChangeInfo:
        subTitle = '개인정보 변경';
        break;
      case RoutesString.ConfirmPassword:
        subTitle = '비밀번호 확인';
        break;
      case RoutesString.Laboratory:
        subTitle = '건축환경연구센터';
        break;
      case RoutesString.Email:
        subTitle = '이메일 무단 수집 거부';
        break;
      case RoutesString.ChangePW:
        subTitle = '비밀번호 변경';
        break;
      case RoutesString.ChangePWRefeat:
        subTitle = '비밀번호 변경 안내';
        break;
      case RoutesString.InitPassword:
        subTitle = '비밀번호 재설정';
        break;
      case RoutesString.IntersetComplex:
        subTitle = '관심 단지';
        break;
      case RoutesString.FooterEvent01:
      case RoutesString.FooterEvent02:
        subTitle = '이벤트';
        break;
      case RoutesString.ContractInfoChange:
        subTitle = '계약 정보 변경';
        break;
      case RoutesString.FooterNotice:
      case RoutesString.FooterNotice2:
        subTitle = '공지사항';
        break;
      case RoutesString.FooterQuestion:
      case RoutesString.FooterQuestion2:
      case RoutesString.FooterQuestion3:
      case RoutesString.FooterQuestion4:
      case RoutesString.FooterQuestion5:
        subTitle = '고객문의';
        break;
      case RoutesString.FooterFoundList:
        subTitle = 'e편한세상 찾기';
        break;
      case RoutesString.Secession:
        subTitle = '회원 탈퇴';
        break;
      case RoutesString.Login:
        subTitle = '로그인';
        break;
      case RoutesString.FindId:
        subTitle = '아이디 찾기';
        break;
      case RoutesString.FindAllId:
        subTitle = '전체 아이디 찾기';
        break;
      case RoutesString.FindPw:
        subTitle = '비밀번호 찾기';
        break;
      case RoutesString.OverLap:
        subTitle = '중복확인';
        break;
      case RoutesString.Schedule:
        subTitle = '연간 분양 일정';
        break;
      default:
        subTitle = '';
    }

    return subTitle;
  };

  return (
    <>
      <ContentWrapper
        style={{
          top: `${headerPos}px`
        }}
        id="headerFixed"
        className={`${isFixed ? 'fixed' : ''}`}>
        <Title>
          <GoLink href={RoutesString.Main}>
            <HideText>e편한세상</HideText>
          </GoLink>
        </Title>
        <SubTitle>{renderSubTitle()}</SubTitle>
        <Link to={RoutesString.Main}>
          <HideText>이전페이지</HideText>
          <PrevIcon aria-hidden="true"></PrevIcon>
        </Link>
        <MenuBtn type="button" onClick={menuFn}>
          <HideText>전체메뉴 열기</HideText>
          {isFixed ? <BlackBurgetIcon aria-hidden="true" /> : <BurgerIcon aria-hidden="true" />}
        </MenuBtn>
      </ContentWrapper>
    </>
  );
});

export default HeaderContent;
